/**
 * ⛔⛔ ЗАМОК ЗАРПЛАТЫ НА ВИЗИТЕ (`s966`, владелец 25.10.2026): визит, по которому
 * уже посчитана зарплата, меняет только руководство и только с причиной.
 *
 * Сервер отказывает ОДНИМ видом на всех дверях визита (состав, цена, продавец,
 * цепочка, оплата и её отмена, филиал, переоткрытие, удаление): `kod =
 * zamok_zarplaty` и `zamok` — `prichina` (руководитель, нужна причина) или
 * `otkaz` (не руководство). Двери разные — 423 у одних, 422 со своим полем у
 * других, — поэтому распознаётся по полям `kod`/`zamok`, а не по статусу и не
 * по тексту.
 *
 * `prichina` — общий перехватчик клиента спрашивает причину и повторяет ход с
 * `zamok_prichina`. `otkaz` — отказ доходит до экрана как любой другой, его
 * словами (их пишет сервер из `ui_terms`).
 */
export const ZAMOK_KOD = 'zamok_zarplaty';
export const ZAMOK_POLE = 'zamok_prichina';

/** Отказ замка «руководителю нужна причина». */
export function zamokProsit(status: number | undefined, data: unknown): boolean {
  if ((status !== 422 && status !== 423) || data === null || typeof data !== 'object') {
    return false;
  }
  const d = data as { kod?: unknown; zamok?: unknown };

  return d.kod === ZAMOK_KOD && d.zamok === 'prichina';
}

/** Слова замка — те, что прислал сервер (утверждённая строка `zapis.zamok_zp.nuzhna_prichina`). */
export function zamokSlova(data: unknown): string {
  const d = (data ?? {}) as { message?: unknown; errors?: Record<string, unknown> };
  const svoe = d.errors?.[ZAMOK_POLE];
  if (Array.isArray(svoe) && typeof svoe[0] === 'string') return svoe[0];
  for (const v of Object.values(d.errors ?? {})) {
    if (Array.isArray(v) && typeof v[0] === 'string') return v[0];
  }

  return typeof d.message === 'string' ? d.message : '';
}
